function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgJavascript(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "76px",
    height: "76px",
    viewBox: "0 0 76 76",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(96.862745%,87.45098%,11.764706%)",
      fillOpacity: 1
    },
    d: "M 10.261719 10.261719 L 65.738281 10.261719 L 65.738281 65.738281 L 10.261719 65.738281 Z M 10.261719 10.261719 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 24.851562 56.621094 L 29.09375 54.050781 C 29.914062 55.511719 30.660156 56.726562 32.4375 56.726562 C 34.15625 56.726562 35.234375 56.058594 35.234375 53.441406 L 35.234375 35.734375 L 40.445312 35.734375 L 40.445312 53.535156 C 40.445312 58.929688 37.285156 61.394531 32.664062 61.394531 C 28.5 61.394531 26.082031 59.234375 24.851562 56.621094 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 43.289062 56.058594 L 47.53125 53.59375 C 48.65625 55.417969 50.097656 56.757812 52.667969 56.757812 C 54.828125 56.757812 56.210938 55.675781 56.210938 54.1875 C 56.210938 52.394531 54.796875 51.769531 52.410156 50.722656 L 51.101562 50.160156 C 47.347656 48.5625 44.839844 46.542969 44.839844 42.300781 C 44.839844 38.394531 47.820312 35.414062 52.46875 35.414062 C 55.785156 35.414062 58.171875 36.570312 59.886719 39.582031 L 55.828125 42.179688 C 54.933594 40.585938 53.976562 39.945312 52.484375 39.945312 C 50.964844 39.945312 49.992188 40.917969 49.992188 42.179688 C 49.992188 43.746094 50.964844 44.382812 53.199219 45.339844 L 54.507812 45.902344 C 58.945312 47.804688 61.4375 49.734375 61.4375 54.097656 C 61.4375 58.792969 57.746094 61.363281 52.804688 61.363281 C 47.941406 61.394531 44.808594 59.082031 43.289062 56.058594 "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJavascript);
export default __webpack_public_path__ + "static/media/javascript.dee3c4dba491d7538e3f70000773fc9e.svg";
export { ForwardRef as ReactComponent };